import { useTranslation } from 'react-i18next';

import { SkeletonGroup } from '../../../../components/LoadingView/LoadingView';
import { LeadPriorityScore } from '../../../../domain/signal';
import type { UseLeadScoringQueryParams } from '../../../../features/leadScoring/useLeadScoringQuery';
import { useLeadScoringQuery } from '../../../../features/leadScoring/useLeadScoringQuery';

import { StyledLeadScoringAgentSummaryText } from './styles';

const SUMMARY_BY_SCORE = {
  [LeadPriorityScore.NoScore]: 'company.signals.lead_scoring_agent.state.no_score.summary',
  [LeadPriorityScore.Unlock]: 'company.signals.lead_scoring_agent.state.unlock.summary',
} as Partial<Record<LeadPriorityScore, string>>;

export const LeadScoringAgentSummary = (props: UseLeadScoringQueryParams) => {
  const { score } = props;
  const { t } = useTranslation();

  const staticSummary = SUMMARY_BY_SCORE[score];
  const isStaticSummary = !!staticSummary;

  const { data, isFetching, isError } = useLeadScoringQuery(!isStaticSummary, props);

  if (isStaticSummary) {
    return <StyledLeadScoringAgentSummaryText isAnimate={false}>{t(staticSummary)}</StyledLeadScoringAgentSummaryText>;
  }

  if (isFetching) {
    return <SkeletonGroup />;
  }

  if (isError || !data?.summary) {
    return null;
  }

  return <StyledLeadScoringAgentSummaryText isAnimate>{data.summary}</StyledLeadScoringAgentSummaryText>;
};
